<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  button {
    margin: 2px; // for outline
    cursor: pointer;
    width: utils.in_rem(24px);
    height: utils.in_rem(24px);
    display: flex;
    align-items: center;
    justify-content: center;

    @include mixins.button-small();

    background-color: transparent;
    color: colors.get(textGrey);
    outline: none;
    border: none;
    border-radius: 8px;

    &.active {
      cursor: default;
      color: colors.get(textWhite);
      background-color: colors.get(primary_50);
    }
    &:not(.active) {
      &:hover,
      &:focus {
        color: colors.get(primary_50);
        background-color: colors.get(primary_5);
      }
      &:focus {
        outline: 2px solid colors.get(primary_40);
      }
    }
  }
</style>

<script>
  let { number, active = false, onclick = () => {} } = $props();
</script>

<button {onclick} class:active disabled={active}>
  {number}
</button>
